import React, { useState, useEffect } from "react";
import { getImageUrl } from "../../api/index";
import { MEDIUM } from '../util/breakpoints';
import { useMediaQuery } from "react-responsive";

// pass loading="eager" to change loading see Hero.js as example
export default props => {
    if(!props || !props.image)
        return <>Image is missing or inaccessible</>;

    const { image: { assetId, title }, loading, ...rest } = props;
    const [url, setUrl] = useState(false);
    const isMobile = useMediaQuery({ maxWidth: MEDIUM-1 });

    const imageSizeQueryString = isMobile ? "w=960&h=540&q=75" : "w=1920&h=1080&q=75"    

    useEffect(() => {
        if (assetId) {
            getImageUrl(assetId).then(image => setUrl(image.file.url));
        }
    });

    if (!url) return null;

    return <img src={ url + "?fm=jpg&fl=progressive&" + imageSizeQueryString } alt={ title } loading={ loading ? loading : "lazy" } { ...rest } />;
}